import { action, computed, observable, makeObservable } from 'mobx';

export class CarouselStore {
  @observable
  maxIndex: number;
  @observable
  index: number;
  @observable
  animating: boolean;

  constructor(maxIndex: number) {
    makeObservable(this);
    this.maxIndex = maxIndex;
    this.index = 0;
    this.animating = false;
  }

  @action
  setMaxIndex(maxIndex: number) {
    this.maxIndex = maxIndex;
    if (this.index > maxIndex)
      this.index = maxIndex;
  }

  @computed
  get first(): boolean {
    return this.index === 0;
  }

  @computed
  get last(): boolean {
    return this.index === this.maxIndex;
  }

  @action
  previous = () => {
    if (this.animating || this.index === 0)
      return;
    this.index--;
  };

  @action
  next = () => {
    if (this.animating || this.index === this.maxIndex)
      return;
    this.index++;
  };

  @action
  setIndex = (newIndex: number) => {
    if (this.index === newIndex)
      return;
    if (newIndex < 0)
      newIndex = 0;
    if (newIndex > this.maxIndex)
      newIndex = this.maxIndex;
    this.index = newIndex;
  }

  @action
  setAnimatingTrue = () => {
    this.animating = true;
  };

  @action
  setAnimatingFalse = () => {
    this.animating = false;
  };

}
